



















import { Vue, Component, Prop } from "vue-property-decorator";
import formatService from "@/services/format";

@Component
export default class Result extends Vue {
    @Prop() result!: HourPrice.Result;

    private format = formatService;
}
